import { EventListener } from "./EventListener";
/**
 * EventsManager defines class which managing events. It has two type event listeners - global and local.
 * Global event listeners are available for every EventsManager instance and local - only for the current one.
 *
 * @typedef EventsManager
 * @type {Object}
 */
var globalListeners = [];
export function PolyfillEventsManager() {
    if (typeof window["EventsManager"] === "undefined") {
        window["EventsManager"] = /** @class */ (function () {
            function EventsManager() {
                this.localListeners = [];
            }
            EventsManager.prototype.addEventListener = function (type, context, callback, global) {
                var listeners = global ? globalListeners : this.localListeners;
                listeners.push(new EventListener(type, callback, context));
            };
            EventsManager.prototype.removeEventListener = function (type, context, global) {
                var listeners = global ? globalListeners : this.localListeners;
                var index = -1;
                for (var i = 0, listenersLength = listeners.length; i < listenersLength; i += 1) {
                    var currentListener = listeners[i];
                    if (currentListener.type === type && currentListener.context === context) {
                        index = i;
                        break;
                    }
                }
                if (index !== -1) {
                    listeners.splice(index, 1);
                }
            };
            EventsManager.prototype.dispatchEvent = function (type, data, global) {
                var listeners = global ? globalListeners : this.localListeners;
                for (var i = 0, listenersLength = listeners.length; i < listenersLength; i += 1) {
                    var currentListener = listeners[i];
                    if (currentListener.type === type) {
                        currentListener.callback.call(currentListener.context, data);
                    }
                }
            };
            EventsManager.prototype.getGlobalEventListeners = function () {
                return globalListeners;
            };
            return EventsManager;
        }());
    }
}
//# sourceMappingURL=PolyfillEventsManager.js.map